export interface StateData {
  id: string
  state: string
  stateCode: string
}

export const statesData: StateData[] = [
  { id: '1', state: 'Alabama', stateCode: 'AL' },
  { id: '2', state: 'Alaska', stateCode: 'AK' },
  { id: '3', state: 'Arizona', stateCode: 'AZ' },
  { id: '4', state: 'Arkansas', stateCode: 'AR' },
  { id: '5', state: 'California', stateCode: 'CA' },
  { id: '6', state: 'Colorado', stateCode: 'CO' },
  { id: '7', state: 'Connecticut', stateCode: 'CT' },
  { id: '8', state: 'Delaware', stateCode: 'DE' },
  { id: '9', state: 'Florida', stateCode: 'FL' },
  { id: '10', state: 'Georgia', stateCode: 'GA' },
  { id: '11', state: 'Hawaii', stateCode: 'HI' },
  { id: '12', state: 'Idaho', stateCode: 'ID' },
  { id: '13', state: 'Illinois', stateCode: 'IL' },
  { id: '14', state: 'Indiana', stateCode: 'IN' },
  { id: '15', state: 'Iowa', stateCode: 'IA' },
  { id: '16', state: 'Kansas', stateCode: 'KS' },
  { id: '17', state: 'Kentucky', stateCode: 'KY' },
  { id: '18', state: 'Louisiana', stateCode: 'LA' },
  { id: '19', state: 'Maine', stateCode: 'ME' },
  { id: '20', state: 'Maryland', stateCode: 'MD' },
  { id: '21', state: 'Massachusetts', stateCode: 'MA' },
  { id: '22', state: 'Michigan', stateCode: 'MI' },
  { id: '23', state: 'Minnesota', stateCode: 'MN' },
  { id: '24', state: 'Mississippi', stateCode: 'MS' },
  { id: '25', state: 'Missouri', stateCode: 'MO' },
  { id: '26', state: 'Montana', stateCode: 'MT' },
  { id: '27', state: 'Nebraska', stateCode: 'NE' },
  { id: '28', state: 'Nevada', stateCode: 'NV' },
  { id: '29', state: 'New Hampshire', stateCode: 'NH' },
  { id: '30', state: 'New Jersey', stateCode: 'NJ' },
  { id: '31', state: 'New Mexico', stateCode: 'NM' },
  { id: '32', state: 'New York', stateCode: 'NY' },
  { id: '33', state: 'North Carolina', stateCode: 'NC' },
  { id: '34', state: 'North Dakota', stateCode: 'ND' },
  { id: '35', state: 'Ohio', stateCode: 'OH' },
  { id: '36', state: 'Oklahoma', stateCode: 'OK' },
  { id: '37', state: 'Oregon', stateCode: 'OR' },
  { id: '38', state: 'Pennsylvania', stateCode: 'PA' },
  { id: '39', state: 'Rhode Island', stateCode: 'RI' },
  { id: '40', state: 'South Carolina', stateCode: 'SC' },
  { id: '41', state: 'South Dakota', stateCode: 'SD' },
  { id: '42', state: 'Tennessee', stateCode: 'TN' },
  { id: '43', state: 'Texas', stateCode: 'TX' },
  { id: '44', state: 'Utah', stateCode: 'UT' },
  { id: '45', state: 'Vermont', stateCode: 'VT' },
  { id: '46', state: 'Virginia', stateCode: 'VA' },
  { id: '47', state: 'Washington', stateCode: 'WA' },
  { id: '48', state: 'West Virginia', stateCode: 'WV' },
  { id: '49', state: 'Wisconsin', stateCode: 'WI' },
  { id: '50', state: 'Wyoming', stateCode: 'WY' },
]
